import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownView"] */ "/vercel/path0/src/components/markdown-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotionView"] */ "/vercel/path0/src/components/notion-view.tsx");
